module.exports = __webpack_public_path__ + "img/shape_rectangle.c301858.webp";